import React, { Component } from 'react'
import { Text,
         View,
         TouchableOpacity,
         FlatList,
         StyleSheet,
         Modal as ModalWeb,
         ScrollView,
         Image,
        } from 'react-native';
import { connect } from 'react-redux';
import {getAllRecords, getAllTaskFromLog, setLogFilter } from '../actions/records';
import { setSubmissionSelected, setIsSubmission, getSubmission } from "../actions/submissions";
import moment from "moment-timezone";
import { setTaskSelected, setFrom } from "../actions/tasks";
import { getGroupDetail, setIsLogGroup } from "../actions/loggroups";
import colors from "../constants/colors";
import Animations from "../components/animations";
import "./styles.css";
import { viewContainer } from "./functions";
import { setPromptTitle } from '../actions/tasks';
import { RecordPaginator } from './recordPaginator';
import { StackActions } from '@react-navigation/native';
import { branding, isBeta } from '../api';
// Use Expo icons on web — react-native-vector-icons fonts do not load in Expo web (empty squares).
import { MaterialCommunityIcons, MaterialCommunityIcons as Icon } from "@expo/vector-icons";
import Swal from "sweetalert2";

const recordTypes = (isLog = false) =>  ([
  {
    label: "All",
    value: "all",
  },
  ...(!isLog 
    ? [
      {
        label: "In Progress",
        value: "in_progress",
      }
    ]
    : []), 
  {
    label: "Edit Required",
    value: "edit_required",
  },
  ...(!isLog
    ? [
      {
        label:"Complete",
        value:"complete"
      }
    ]
    :[]),
  {
    label: "Approved",
    value: "approved",
  },
  ...(!isLog
    ? [
        {
          label: "Archived",
          value: "archived",
        },
      ]
    : []),
  ...(isLog
    ? [
        {
          label: "Archived",
          value: "archive",
        },
      ]
    : []),
  ...(isLog 
    ? [
        {
          label: "In Progress",
          value: "pending",
        }
      ]
    : []), 
]);
  


const IQOPS_RECORD_FILTER_BUBBLES = [
  {
    key: "all",
    label: "All",
    iconType: "mci",
    icon: "view-grid-outline",
  },
  {
    key: "status",
    label: "Status",
    iconType: "mci",
    icon: "format-list-bulleted",
  },
  {
    key: "dateRange",
    label: "Date Range",
    iconType: "mci",
    icon: "calendar-month-outline",
  },
  {
    key: "compliance",
    label: "Compliance",
    iconType: "mci",
    icon: "clipboard-text-outline",
  },
  {
    key: "inventory",
    label: "Inventory",
    iconType: "mci",
    icon: "cube-outline",
  },
  {
    key: "production",
    label: "Production",
    iconType: "mci",
    icon: "factory",
  },
];

const IQOPS_STATUS_FILTER_OPTIONS = [
  {
    label: "In Progress",
    value: "in_progress",
    color: colors.in_progress,
  },
  {
    label: "Edit Required",
    value: "edit_required",
    color: colors.edit_required,
  },
  {
    label: "Complete",
    value: "complete",
    color: colors.complete,
  },
  {
    label: "Approved",
    value: "approved",
    color: colors.approved,
  },
  {
    label: "Archived",
    value: "archived",
    color: colors.archived,
  },
];

const getIqopsStatusIconName = (status) => {
  switch (status) {
    case "edit_required":
      return "pencil";
    case "in_progress":
    case "pending":
      return "clock-outline";
    case "archived":
    case "archive":
      return "archive-outline";
    case "approved":
      return "shield-check-outline";
    case "complete":
    default:
      return "check-circle-outline";
  }
};

const IQOPS_DATE_RANGE_OPTIONS = [
  { key: "custom", label: "Custom" },
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "last7", label: "Last 7 days" },
  { key: "last14", label: "Last 14 days" },
  { key: "last30", label: "Last 30 days" },
  { key: "thisWeekSun", label: "This week (Sun - Today)" },
  { key: "thisWeekMon", label: "This week (Mon - Today)" },
  { key: "lastWeekSun", label: "Last week (Sun - Sat)" },
  { key: "lastWeekMon", label: "Last week (Mon - Sun)" },
  { key: "thisMonth", label: "This month" },
];

const IQOPS_INVENTORY_SUBFILTERS = [
  { key: "isReceivingLog", label: "Receiving Log", icon: "forklift" },
  { key: "isShipmentLog", label: "Shipment Log", icon: "truck" },
  { key: "isShipmentByLocation", label: "Shipment By Location", icon: "map-marker-path" },
  { key: "isInventoryTransfer", label: "Inventory Transfer", icon: "swap-horizontal" },
  { key: "isTransferByLocation", label: "Transfer By Location", icon: "map-marker-distance" },
];

const formatApiDate = (m) => moment(m).format("YYYY-MM-DD");

const getIqopsDateRangeForKey = (key) => {
  const today = moment().startOf("day");
  switch (key) {
    case "today":
      return { startDate: formatApiDate(today), endDate: formatApiDate(today) };
    case "yesterday": {
      const d = today.clone().subtract(1, "day");
      return { startDate: formatApiDate(d), endDate: formatApiDate(d) };
    }
    case "last7":
      return {
        startDate: formatApiDate(today.clone().subtract(6, "days")),
        endDate: formatApiDate(today),
      };
    case "last14":
      return {
        startDate: formatApiDate(today.clone().subtract(13, "days")),
        endDate: formatApiDate(today),
      };
    case "last30":
      return {
        startDate: formatApiDate(today.clone().subtract(29, "days")),
        endDate: formatApiDate(today),
      };
    case "thisWeekSun":
      return {
        startDate: formatApiDate(today.clone().startOf("week")),
        endDate: formatApiDate(today),
      };
    case "thisWeekMon":
      return {
        startDate: formatApiDate(today.clone().startOf("isoWeek")),
        endDate: formatApiDate(today),
      };
    case "lastWeekSun": {
      const start = today.clone().startOf("week").subtract(1, "week");
      const end = start.clone().add(6, "days");
      return { startDate: formatApiDate(start), endDate: formatApiDate(end) };
    }
    case "lastWeekMon": {
      const start = today.clone().startOf("isoWeek").subtract(1, "week");
      const end = start.clone().add(6, "days");
      return { startDate: formatApiDate(start), endDate: formatApiDate(end) };
    }
    case "thisMonth":
      return {
        startDate: formatApiDate(today.clone().startOf("month")),
        endDate: formatApiDate(today),
      };
    default:
      return { startDate: null, endDate: null };
  }
};

class Records extends Component {
    constructor(props) {
      super(props);
      this.state = {
        filter: 'all',
        filterOpen: false,
        filterLog:'all',
        filterLogOpen: false,
        showRecords: branding === "iqops",
        showLogs: false,
        btnName: "Show Reports",
        btnNameLog: "Show Logs Reports",
        width: window.innerWidth,
        dateRangeOpen: false,
        dateRangeCustomOpen: false,
        dateRangeKey: null,
        startDate: null,
        endDate: null,
        customStartDate: null,
        customEndDate: null,
        calendarMonth: moment().startOf("month"),
        complianceSelected: false,
        inventorySelected: false,
        inventorySubfilter: null,
        productionSelected: false,
      };      
    }

    handleResize = () => {
      this.setState({width: window.innerWidth});
    }

    componentDidMount(){
        this.props.getAllRecords({page:1});
        // Logs feature intentionally disabled for this PR. Restore by uncommenting below and the "Show Logs" UI block (~line 497), or gate behind a feature flag.
        // this.props.getAllTaskFromLog({page:1});
        window.addEventListener('resize', this.handleResize);
    }

    componentDidUpdate(prevProps, prevState){
      if(prevProps.LogFilter != null && this.props.LogFilter == null){
        this.setState({filter: 'all', filterLog: 'all'});
      }
      if(prevProps.approved != this.props.approved){
        this.filterRecords(this.props.currentPage);
      }
      if(this.props.records?.records != prevProps?.records?.records &&  this.props.records?.records?.length > 0){
        this.setState({ showRecords: true });
      }
    }

    componentWillUnmount(){
      window.removeEventListener('resize', this.handleResize);
    }

  clearIqopsFilters = () => {
    this.setState({
      filter: "all",
      filterOpen: false,
      dateRangeOpen: false,
      dateRangeCustomOpen: false,
      dateRangeKey: null,
      startDate: null,
      endDate: null,
      customStartDate: null,
      customEndDate: null,
      complianceSelected: false,
      inventorySelected: false,
      inventorySubfilter: null,
      productionSelected: false,
    });
    this.props.setFilter("all");
    setTimeout(() => {
      this.filterRecords(1);
    }, 50);
  };

  buildIqopsFormTypeFlags = () => {
    const {
      complianceSelected,
      inventorySelected,
      inventorySubfilter,
      productionSelected,
    } = this.state;
    const flags = {};
    if (complianceSelected) flags.standardForm = true;
    if (productionSelected) flags.productionForms = true;
    if (inventorySelected) {
      if (inventorySubfilter) {
        flags[inventorySubfilter] = true;
      } else {
        flags.inventoryForms = true;
      }
    }
    return flags;
  };

  toggleCategoryFilter = (key) => {
    if (key === "compliance") {
      this.setState(
        (prev) => ({ complianceSelected: !prev.complianceSelected }),
        () => this.filterRecords(1)
      );
      return;
    }
    if (key === "production") {
      this.setState(
        (prev) => ({ productionSelected: !prev.productionSelected }),
        () => this.filterRecords(1)
      );
      return;
    }
    if (key === "inventory") {
      this.setState((prev) => {
        const nextSelected = !prev.inventorySelected;
        return {
          inventorySelected: nextSelected,
          inventorySubfilter: nextSelected ? prev.inventorySubfilter : null,
        };
      }, () => this.filterRecords(1));
    }
  };

  selectInventorySubfilter = (subKey) => {
    this.setState((prev) => ({
      inventorySubfilter: prev.inventorySubfilter === subKey ? null : subKey,
    }), () => this.filterRecords(1));
  };

  onIqopsFilterBubblePress = (key) => {
    if (key === "all") {
      this.clearIqopsFilters();
      return;
    }
    if (key === "status") {
      this.setState({
        filterOpen: true,
        dateRangeOpen: false,
        dateRangeCustomOpen: false,
      });
      return;
    }
    if (key === "dateRange") {
      this.setState({
        dateRangeOpen: true,
        filterOpen: false,
        dateRangeCustomOpen: false,
      });
      return;
    }
    if (key === "compliance" || key === "inventory" || key === "production") {
      this.setState({
        filterOpen: false,
        dateRangeOpen: false,
        dateRangeCustomOpen: false,
      });
      this.toggleCategoryFilter(key);
    }
  };

  getDateRangeBubbleLabel = () => {
    const { dateRangeKey, startDate, endDate } = this.state;
    if (!startDate || !endDate) return "Date Range";
    if (dateRangeKey === "custom") {
      return `${moment(startDate).format("MMM D")} - ${moment(endDate).format("MMM D")}`;
    }
    const option = IQOPS_DATE_RANGE_OPTIONS.find((o) => o.key === dateRangeKey);
    return option?.label || "Date Range";
  };

  renderIqopsFilterBubble = (bubble, options = {}) => {
    const {
      isActive = false,
      isSubfilter = false,
      labelOverride = null,
      onPress,
    } = options;
    return (
      <TouchableOpacity
        key={bubble.key}
        style={[
          styles.iqopsFilterBubble,
          isSubfilter && styles.iqopsFilterSubBubble,
          isActive && !isSubfilter && styles.iqopsFilterBubbleActive,
          isActive && isSubfilter && styles.iqopsFilterSubBubbleActive,
        ]}
        activeOpacity={0.75}
        onPress={onPress}
      >
        {bubble.iconType === "image" ? (
          <Image
            source={bubble.source}
            style={[
              styles.iqopsFilterBubbleIconImg,
              isActive && !isSubfilter && styles.iqopsFilterBubbleIconImgActive,
            ]}
            resizeMode="contain"
          />
        ) : (
          <Icon
            name={bubble.icon}
            size={18}
            color={
              isActive && !isSubfilter
                ? "#FFFFFF"
                : isActive && isSubfilter
                  ? "#1A1A1A"
                  : "#5A6578"
            }
            style={[
              styles.iqopsFilterBubbleIconMci,
              isActive && !isSubfilter && styles.iqopsFilterBubbleIconMciActive,
              isActive && isSubfilter && styles.iqopsFilterSubBubbleIconActive,
            ]}
          />
        )}
        <Text
          style={[
            styles.iqopsFilterBubbleLabel,
            isActive && !isSubfilter && styles.iqopsFilterBubbleLabelActive,
            isActive && isSubfilter && styles.iqopsFilterSubBubbleLabelActive,
            isSubfilter && styles.iqopsFilterSubBubbleLabel,
          ]}
          numberOfLines={1}
        >
          {labelOverride || bubble.label}
        </Text>
      </TouchableOpacity>
    );
  };

  renderIqopsFilterBubbles = () => {
    const {
      filter,
      filterOpen,
      dateRangeOpen,
      dateRangeCustomOpen,
      startDate,
      endDate,
      complianceSelected,
      inventorySelected,
      inventorySubfilter,
      productionSelected,
    } = this.state;
    const hasStatusFilter = filter !== "all";
    const hasDateFilter = Boolean(startDate && endDate);
    const hasCategoryFilter =
      complianceSelected || inventorySelected || productionSelected;
    const hasActiveFilters =
      hasStatusFilter || hasDateFilter || hasCategoryFilter;
    const dateModalOpen = dateRangeOpen || dateRangeCustomOpen;

    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={styles.iqopsFilterScroll}
        contentContainerStyle={styles.iqopsFilterScrollContent}
      >
        {IQOPS_RECORD_FILTER_BUBBLES.flatMap((bubble) => {
          const isStatus = bubble.key === "status";
          const isDateRange = bubble.key === "dateRange";
          const isAll = bubble.key === "all";
          const isCompliance = bubble.key === "compliance";
          const isInventory = bubble.key === "inventory";
          const isProduction = bubble.key === "production";
          const isActive = isAll
            ? !hasActiveFilters && !filterOpen && !dateModalOpen
            : isStatus
              ? filterOpen || hasStatusFilter
              : isDateRange
                ? dateModalOpen || hasDateFilter
                : isCompliance
                  ? complianceSelected
                  : isInventory
                    ? inventorySelected
                    : isProduction
                      ? productionSelected
                      : false;

          const nodes = [
            this.renderIqopsFilterBubble(bubble, {
              isActive,
              labelOverride: isStatus && hasStatusFilter
                ? this.translateStatus(filter)
                : isDateRange && hasDateFilter
                  ? this.getDateRangeBubbleLabel()
                  : null,
              onPress: () => this.onIqopsFilterBubblePress(bubble.key),
            }),
          ];

          if (isInventory && inventorySelected) {
            IQOPS_INVENTORY_SUBFILTERS.forEach((sub) => {
              nodes.push(
                this.renderIqopsFilterBubble(
                  { key: sub.key, label: sub.label, icon: sub.icon },
                  {
                    isActive: inventorySubfilter === sub.key,
                    isSubfilter: true,
                    onPress: () => this.selectInventorySubfilter(sub.key),
                  }
                )
              );
            });
          }

          return nodes;
        })}
      </ScrollView>
    );
  };

  closeIqopsStatusFilter = () => {
    this.setState({ filterOpen: false });
  };

  selectIqopsStatusFilter = (value) => {
    this.setState({ filter: value, filterOpen: false });
    this.props.setFilter(value);
    setTimeout(() => {
      this.filterRecords();
    }, 50);
  };

  iqopsStatusFilterItem = (item) => {
    const selected = item.value === this.state.filter;
    return (
      <TouchableOpacity
        style={[
          styles.iqopsStatusRow,
          selected && styles.iqopsStatusRowSelected,
        ]}
        activeOpacity={0.75}
        onPress={() => this.selectIqopsStatusFilter(item.value)}
      >
        <View
          style={[
            styles.iqopsStatusRowBadge,
            { backgroundColor: item.color },
          ]}
        >
          <Icon
            name={getIqopsStatusIconName(item.value)}
            size={16}
            color="#FFFFFF"
            style={styles.iqopsStatusRowBadgeIcon}
          />
        </View>
        <Text
          style={[
            styles.iqopsStatusRowLabel,
            !selected && item.color ? { color: item.color } : null,
            selected && styles.iqopsStatusRowLabelSelected,
          ]}
        >
          {item.label}
        </Text>
      </TouchableOpacity>
    );
  };

  renderIqopsStatusModal = () => (
    <ModalWeb
      animationType="fade"
      transparent={true}
      visible={this.state.filterOpen}
      onRequestClose={this.closeIqopsStatusFilter}
    >
      <TouchableOpacity
        style={styles.iqopsStatusModalOverlay}
        activeOpacity={1}
        onPress={this.closeIqopsStatusFilter}
      >
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => {}}
          style={styles.iqopsStatusModalCard}
        >
          <View style={styles.iqopsStatusModalHeader}>
            <Text style={styles.iqopsStatusModalTitle}>Status</Text>
            <TouchableOpacity
              onPress={this.closeIqopsStatusFilter}
              hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
            >
              <Icon name="close" size={26} color="#7EB6E8" style={styles.iqopsStatusModalClose} />
            </TouchableOpacity>
          </View>
          <View style={styles.iqopsStatusModalList}>
            {IQOPS_STATUS_FILTER_OPTIONS.map((item, index) => (
              <View key={item.value}>
                {index > 0 ? <View style={styles.iqopsStatusDivider} /> : null}
                {this.iqopsStatusFilterItem(item)}
              </View>
            ))}
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </ModalWeb>
  );

  closeIqopsDateRangeFilter = () => {
    this.setState({ dateRangeOpen: false, dateRangeCustomOpen: false });
  };

  applyIqopsDateRange = (key, startDate, endDate) => {
    this.setState({
      dateRangeKey: key,
      startDate,
      endDate,
      dateRangeOpen: false,
      dateRangeCustomOpen: false,
    });
    setTimeout(() => {
      this.filterRecords(1);
    }, 50);
  };

  selectIqopsDateRangePreset = (key) => {
    if (key === "custom") {
      const { startDate, endDate, calendarMonth } = this.state;
      this.setState({
        dateRangeOpen: false,
        dateRangeCustomOpen: true,
        customStartDate: startDate || formatApiDate(moment()),
        customEndDate: endDate || formatApiDate(moment()),
        calendarMonth: startDate
          ? moment(startDate).startOf("month")
          : calendarMonth || moment().startOf("month"),
      });
      return;
    }
    const range = getIqopsDateRangeForKey(key);
    this.applyIqopsDateRange(key, range.startDate, range.endDate);
  };

  onCustomCalendarDayPress = (dayMoment) => {
    const day = formatApiDate(dayMoment);
    const { customStartDate, customEndDate } = this.state;
    if (!customStartDate || (customStartDate && customEndDate)) {
      this.setState({ customStartDate: day, customEndDate: null });
      return;
    }
    if (moment(day).isBefore(customStartDate, "day")) {
      this.setState({ customStartDate: day, customEndDate: customStartDate });
    } else {
      this.setState({ customEndDate: day });
    }
  };

  applyCustomDateRange = () => {
    const { customStartDate, customEndDate } = this.state;
    if (!customStartDate || !customEndDate) {
      Swal.fire({
        title: "Date Range",
        text: "Please select a start and end date.",
        icon: "warning",
      });
      return;
    }
    this.applyIqopsDateRange("custom", customStartDate, customEndDate);
  };

  shiftCalendarMonth = (delta) => {
    this.setState((prev) => ({
      calendarMonth: moment(prev.calendarMonth).add(delta, "month").startOf("month"),
    }));
  };

  getCustomRangeLabel = () => {
    const { customStartDate, customEndDate } = this.state;
    if (!customStartDate) return "Select dates";
    if (!customEndDate) return moment(customStartDate).format("MMM D");
    return `${moment(customStartDate).format("MMM D")} - ${moment(customEndDate).format("MMM D")}`;
  };

  isDayInCustomRange = (dayMoment) => {
    const { customStartDate, customEndDate } = this.state;
    if (!customStartDate || !customEndDate) return false;
    return (
      dayMoment.isSameOrAfter(customStartDate, "day") &&
      dayMoment.isSameOrBefore(customEndDate, "day")
    );
  };

  renderIqopsCustomCalendar = () => {
    const { calendarMonth, customStartDate, customEndDate } = this.state;
    const startOfMonth = moment(calendarMonth).startOf("month");
    const startGrid = startOfMonth.clone().startOf("week");
    const days = [];
    for (let i = 0; i < 42; i += 1) {
      days.push(startGrid.clone().add(i, "days"));
    }
    const weekDays = ["S", "M", "T", "W", "T", "F", "S"];

    return (
      <View style={styles.iqopsCalendarWrap}>
        <View style={styles.iqopsCalendarHeader}>
          <TouchableOpacity onPress={() => this.shiftCalendarMonth(-1)} hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
            <Icon name="chevron-left" size={24} color="#1A1A1A" style={styles.iqopsCalendarNavIcon} />
          </TouchableOpacity>
          <Text style={styles.iqopsCalendarMonthLabel}>
            {moment(calendarMonth).format("MMMM YYYY")}
          </Text>
          <TouchableOpacity onPress={() => this.shiftCalendarMonth(1)} hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
            <Icon name="chevron-right" size={24} color="#1A1A1A" style={styles.iqopsCalendarNavIcon} />
          </TouchableOpacity>
        </View>
        <View style={styles.iqopsCalendarWeekRow}>
          {weekDays.map((d, idx) => (
            <Text key={`${d}-${idx}`} style={styles.iqopsCalendarWeekDay}>{d}</Text>
          ))}
        </View>
        <View style={styles.iqopsCalendarGrid}>
          {days.map((day) => {
            const inMonth = day.month() === moment(calendarMonth).month();
            const isStart = customStartDate && day.isSame(customStartDate, "day");
            const isEnd = customEndDate && day.isSame(customEndDate, "day");
            const inRange = this.isDayInCustomRange(day);
            const isEdge = isStart || isEnd;
            return (
              <TouchableOpacity
                key={day.format("YYYY-MM-DD")}
                style={[
                  styles.iqopsCalendarDayCell,
                  inRange && styles.iqopsCalendarDayInRange,
                  isStart && styles.iqopsCalendarDayRangeStart,
                  isEnd && styles.iqopsCalendarDayRangeEnd,
                ]}
                activeOpacity={0.7}
                onPress={() => this.onCustomCalendarDayPress(day)}
              >
                <View
                  style={[
                    styles.iqopsCalendarDayInner,
                    isEdge && styles.iqopsCalendarDayInnerSelected,
                  ]}
                >
                  <Text
                    style={[
                      styles.iqopsCalendarDayText,
                      !inMonth && styles.iqopsCalendarDayTextMuted,
                      isEdge && styles.iqopsCalendarDayTextSelected,
                    ]}
                  >
                    {day.date()}
                  </Text>
                </View>
              </TouchableOpacity>
            );
          })}
        </View>
      </View>
    );
  };

  renderIqopsDateRangeModal = () => (
    <ModalWeb
      animationType="fade"
      transparent={true}
      visible={this.state.dateRangeOpen}
      onRequestClose={this.closeIqopsDateRangeFilter}
    >
      <TouchableOpacity
        style={styles.iqopsStatusModalOverlay}
        activeOpacity={1}
        onPress={this.closeIqopsDateRangeFilter}
      >
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => {}}
          style={[styles.iqopsStatusModalCard, styles.iqopsDateRangeModalCard]}
        >
          <View style={styles.iqopsDateRangeModalHeader}>
            <Text style={styles.iqopsDateRangeModalTitle}>Date Range</Text>
            <TouchableOpacity
              style={styles.iqopsDateRangeModalCloseBtn}
              onPress={this.closeIqopsDateRangeFilter}
              hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
            >
              <Icon name="close" size={26} color="#7EB6E8" style={styles.iqopsStatusModalClose} />
            </TouchableOpacity>
          </View>
          <ScrollView
            style={styles.iqopsDateRangeList}
            showsVerticalScrollIndicator={false}
          >
            {IQOPS_DATE_RANGE_OPTIONS.map((item, index) => {
              const selected = this.state.dateRangeKey === item.key;
              return (
                <View key={item.key}>
                  {index > 0 ? <View style={styles.iqopsDateRangeDivider} /> : null}
                  <TouchableOpacity
                    style={[
                      styles.iqopsDateRangeRow,
                      selected && styles.iqopsStatusRowSelected,
                    ]}
                    activeOpacity={0.75}
                    onPress={() => this.selectIqopsDateRangePreset(item.key)}
                  >
                    <Text
                      style={[
                        styles.iqopsDateRangeRowLabel,
                        selected && styles.iqopsStatusRowLabelSelected,
                      ]}
                    >
                      {item.label}
                    </Text>
                  </TouchableOpacity>
                </View>
              );
            })}
          </ScrollView>
        </TouchableOpacity>
      </TouchableOpacity>
    </ModalWeb>
  );

  renderIqopsCustomDateModal = () => (
    <ModalWeb
      animationType="fade"
      transparent={true}
      visible={this.state.dateRangeCustomOpen}
      onRequestClose={this.closeIqopsDateRangeFilter}
    >
      <TouchableOpacity
        style={styles.iqopsStatusModalOverlay}
        activeOpacity={1}
        onPress={this.closeIqopsDateRangeFilter}
      >
        <TouchableOpacity
          activeOpacity={1}
          onPress={() => {}}
          style={[styles.iqopsStatusModalCard, styles.iqopsCustomDateModalCard]}
        >
          <View style={styles.iqopsStatusModalHeader}>
            <Text style={styles.iqopsStatusModalTitle}>Custom</Text>
            <TouchableOpacity
              onPress={this.closeIqopsDateRangeFilter}
              hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
            >
              <Icon name="close" size={26} color="#7EB6E8" style={styles.iqopsStatusModalClose} />
            </TouchableOpacity>
          </View>
          <View style={styles.iqopsCustomRangeLabelRow}>
            <Text style={styles.iqopsCustomRangeLabel}>
              {this.getCustomRangeLabel()}
            </Text>
            <Icon name="pencil" size={18} color={colors.primary} style={styles.iqopsCustomRangeEditIcon} />
          </View>
          {this.renderIqopsCustomCalendar()}
          <TouchableOpacity
            style={styles.iqopsCustomApplyBtn}
            activeOpacity={0.8}
            onPress={this.applyCustomDateRange}
          >
            <Text style={styles.iqopsCustomApplyBtnText}>Apply</Text>
          </TouchableOpacity>
        </TouchableOpacity>
      </TouchableOpacity>
    </ModalWeb>
  );

    translateStatus(name){
        switch(name){
            case "all" : return "All";
            case "in_progress" : return "In Progress";
            case "edit_required" : return "Edit Required";
            case "complete" : return "Complete";
            case "approved" : return "Approved";
            case "archived" : return "Archived";
            case "logroups" : return "Form Groups";
            case "archive" : return "Archive";
            case "pending" : return "Pending";
            default : "In Progress";            
        }
    }

    translateIcon(name){
        switch(name){
            case "all" : return "filter-variant";
            case "in_progress" : return "progress-clock";
            case "edit_required" : return "lead-pencil";
            case "complete" : return "checkbox-marked-circle";            
            case "approved" : return "checkbox-marked-circle"; 
            case "archived" :
            case "archive": 
              return "checkbox-marked-circle";    
            case "logroups" : return "apps";         
            default : return "progress-clock";
        }
    }

    getIconStyle(name){
      switch(name){
          case "in_progress" : return styles.iconInProgress;
          case "edit_required" : return styles.iconEditRequired;
          case "complete" : return styles.iconReadyForReview;
          case "approved" : return styles.iconReadyForApproval;
          case "archived" : 
          case "archive": 
            return styles.iconArchived;           
          default : return styles.iconDefault;
      }
  }

  getTimeConverted(date) {
    let d = moment.tz(date, "UTC");  
    if( moment.tz(d, moment.tz.guess(true)).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD"))
      return "Today at " + moment.tz(d, moment.tz.guess(true)).format("H:mm");
    else
      return moment.tz(d, moment.tz.guess(true)).format("MM/DD/YYYY");
  }

  getReportsByItemFiltered(){
    
  }
  delay(n){
    return new Promise(function(resolve){
        setTimeout(resolve,n*100);
    });
  }

 async getReportsbyItemClicked(){

    await this.delay(2);
    this.filterRecords();
}
async getLogReportsbyItemClicked(){

  await this.delay(2);
  this.filterLogRecords();
}


  filterItem(item){
    return (
      <TouchableOpacity style={item.value== this.state.filter ? styles.filterItemSelected : styles.filterItem} onPress={
        ()=> {
          this.props.setFilter(item.value);
          this.setState({filter: item.value})
          this.setState({ filterOpen: false });
          this.getReportsbyItemClicked()
        } 
        }>

        <View style={styles.iconContainer}>
          <MaterialCommunityIcons 
                  name={this.translateIcon(item.value)} 
                  style={this.getIconStyle(item.value)}
                />
        </View>
        <View style={styles.recordContainer}>
          <Text style={{padding: 10, fontSize: 15}}>{item.label}</Text>
        </View>
        
      </TouchableOpacity>
      
    );
  }

  filterLogItem(item){
    return (
      <TouchableOpacity style={item.value== this.state.filterLog ? styles.filterItemSelected : styles.filterItem} onPress={
        ()=> {
          this.props.setFilter(item.value);
          this.setState({filterLog: item.value})
          this.setState({ filterLogOpen: false })
          this.getLogReportsbyItemClicked()
        }}>

        <View style={styles.iconContainer}>
          <MaterialCommunityIcons 
                  name={this.translateIcon(item.value)} 
                  style={this.getIconStyle(item.value)}
                />
        </View>
        <View style={styles.recordContainer}>
          <Text style={{padding: 10, fontSize: 15}}>{item.label}</Text>
        </View>    
      </TouchableOpacity>
      
    );
  } 

  getIqopsDate(date) {
    if (!date) return "";
    let d = moment.tz(date, "UTC");
    return moment.tz(d, moment.tz.guess(true)).format("MM/DD/YYYY");
  }

  getIqopsStatusColor(status) {
    switch (status) {
      case "edit_required":
        return colors.edit_required;
      case "in_progress":
      case "pending":
        return colors.in_progress;
      case "approved":
        return colors.approved;
      case "archived":
      case "archive":
        return colors.archived;
      case "complete":
      default:
        return colors.complete;
    }
  }

  Item(item) {      
    const { loadingRecord } = this.props;    
      const createdAt = this.getTimeConverted(item.created_at);
      const isIqops = branding === "iqops";

      if (isIqops) {
        const created = this.getIqopsDate(item.created_at);
        const updated = this.getIqopsDate(item.updated_at);
        const statusColor = this.getIqopsStatusColor(item.status);
        return (
          <TouchableOpacity
            style={styles.iqopsCard}
            activeOpacity={0.75}
            disabled={loadingRecord}
            onPress={() => {
              this.props.getSubmission(item._id, (itm)=>{
                const chatIndex = itm.components.findIndex( component => component.type == 'chatAI' );
                if( chatIndex > -1 ){
                  const componentId = itm?.components[chatIndex]?.id;
                  const category = itm?.submission[componentId]?.category || null;
                  if(category){
                    this.props.setPromptTitle(itm?.name);
                    setTimeout(() => {
                      this.props.navigation.dispatch(StackActions.push('PromptFormView', { initialResponse: { response: itm?.submission[componentId]?.response }, completed: true }));
                    }, 200);
                    return;
                  }
                }
                this.props.setFrom("Review Reports");
                this.props.setIsSubmission(true);
                this.props.navigateRecord(
                  itm.id,
                  itm.name,
                  false,
                  itm?.isPallet,
                  itm?.isReceivingLog,
                  itm?.isOrder,
                  itm?.isRecipe,
                  itm?.defaultYield,
                  itm?.isInvoice,
                  itm?.isShipmentLog,
                  itm?.isReconciliationLog,
                  itm?.isInventoryTransfer,
                  itm?.complete_date,
                  itm?.isShipmentByLocation,
                  itm?.isTransferByLocation
                );
                this.props.setTaskSelected({});
              });
            }}
          >
            <View style={[styles.iqopsStatusBadge, { backgroundColor: statusColor }]}>
              <Icon
                name={getIqopsStatusIconName(item.status)}
                size={22}
                color="#FFFFFF"
                style={styles.iqopsStatusIcon}
              />
            </View>
            <View style={styles.iqopsCardBody}>
              <Text style={styles.iqopsRecordName} numberOfLines={2}>
                {item.name}
              </Text>
              <Text style={styles.iqopsCreatedAt}>Created at: {created}</Text>
            </View>
            <Text style={styles.iqopsUpdatedAt}>{updated}</Text>
          </TouchableOpacity>
        );
      }

      return (
          <TouchableOpacity 
              style={styles.item}
              disabled={loadingRecord}
              onPress={() => {    
                this.props.getSubmission(item._id, (itm)=>{
                  const chatIndex = itm.components.findIndex( component => component.type == 'chatAI' );
                  if( chatIndex > -1 ){
                    const componentId = itm?.components[chatIndex]?.id;
                    const category = itm?.submission[componentId]?.category || null;
                    if(category){
                      this.props.setPromptTitle(itm?.name);
                      setTimeout(() => {
                        this.props.navigation.dispatch(StackActions.push('PromptFormView', { initialResponse: { response: itm?.submission[componentId]?.response }, completed: true }));
                      }, 200);
                      return;
                    }
                  }
                  //this.props.setSubmissionSelected({ ...itm }); 
                  this.props.setFrom("Review Reports");
                  this.props.setIsSubmission(true);
                  this.props.navigateRecord(
                    itm.id,
                    itm.name,
                    false,
                    itm?.isPallet,
                    itm?.isReceivingLog,
                    itm?.isOrder,
                    itm?.isRecipe,
                    itm?.defaultYield,
                    itm?.isInvoice,
                    itm?.isShipmentLog,
                    itm?.isReconciliationLog,
                    itm?.isInventoryTransfer,
                    itm?.complete_date,
                    itm?.isShipmentByLocation,
                    itm?.isTransferByLocation
                  );
                  this.props.setTaskSelected({});
                 });  
                }}
              >
            <View style={styles.iconContainer}>
              <MaterialCommunityIcons 
                name={this.translateIcon(item.status)} 
                style={this.getIconStyle(item.status)}
              />
            </View>
            <View style={styles.recordContainer}>
                <View style={styles.itemsBody}>      
                  <View style={styles.smartBox}>    
                      <Text style={styles.recordName}>{item.name}</Text>                                         
                  </View>                    
                </View>
                <View style={styles.itemsFooter}>
                  { typeof item.owner != "undefined" &&
                    <View style={styles.smartBox}>                   
                      <Text style={styles.transactionPeer}>{item.owner.first_name + " " + item.owner.last_name}</Text>
                    </View>
                  }    
                  <View style={styles.smartBox}>  
                    <Text style={styles.recordDate}>{this.getTimeConverted(item.updated_at)}</Text>
                  </View>  
                </View>
                <Text>
                  Created at: {createdAt}
                </Text>
              </View>
          </TouchableOpacity>          
      );
    }

    TaskItem(item) {
      const createdAt = this.getTimeConverted(item.created_at);
      return (
          <TouchableOpacity 
              style={styles.item}
              onPress={() => {     
                  this.props.setTaskSelected({...item});
                  this.props.getGroupDetail(item.log_group_id, item?.sig);   
                  this.props.setIsLogGroup(true);
                  this.props.navigation.navigate('GroupView', { signature: item?.sig });            
                }}
              >
            <View style={styles.iconContainer}>
              <MaterialCommunityIcons 
                name={this.translateIcon(item.status)} 
                style={this.getIconStyle(item.status)}
              />
            </View>
            <View style={styles.recordContainer}>
                <View style={styles.itemsBody}>      
                  <View style={styles.smartBox}>    
                      <Text style={styles.recordName}>{item.name}</Text>                                         
                  </View>                    
                </View>
                <View style={styles.itemsFooter}>
                  <View style={styles.smartBox}>  
                    <Text style={styles.recordDate}>{this.getTimeConverted(item.updated_at)}</Text>
                  </View>  
                </View>
                <Text>
                  Created at: {createdAt}
                </Text>
              </View>
          </TouchableOpacity>          
      );
      
    }


    filterRecords(page){
      const {filter, startDate, endDate} = this.state;
      const { getAllRecords } = this.props;
      getAllRecords({
        page: page ? page : 1,
        ...( filter != 'all' && { filter }  ),
        ...(startDate && endDate && { startDate, endDate }),
        ...(branding === "iqops" ? this.buildIqopsFormTypeFlags() : {}),
      });
    }

    filterLogRecords(){
      const {filterLog} = this.state;
      const {getAllTaskFromLog} = this.props;
      switch(filterLog){
        case "all":
          getAllTaskFromLog({page: 1 });
          break;
        default:
          getAllTaskFromLog({page: 1, filter: filterLog});
          break;
      }
    }

    totalReports() {
      const {records} = this.props;
      let tasksCount = records.totalCount;
      return <View
        style={{
          flex: 1,
          flexDirection: "row",
          backgroundColor: colors.primary,
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text style={{ color: "#fff", fontSize: 18 }}>
          Total Reports: {tasksCount}
        </Text>
      </View>
    }
  
    totalLogs() {
      const {taskLogCount} = this.props;
      return <View
        style={{
          flex: 1,
          flexDirection: "row",
          backgroundColor: colors.primary,
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text style={{ color: "#fff", fontSize: 18 }}>
          Total Logs: {taskLogCount}
        </Text>
      </View>
    }

    render() {
        const {
          records, logRecords, tasksStatus, recordsLoading, currentPage,  pageSize, getAllRecords,
          currentLogPage, taskLogCount, logPageSize, getAllTaskFromLog 
        } = this.props; 
        const {filter, filterLog} = this.state;
        let recordsVar = records?.records ? records.records : [];
        const headerSearch = (this.props.headerSearch || "").toLowerCase().trim();
        // Header owns search for iqops — filter client-side; no local search UI.
        if (branding === "iqops" && headerSearch) {
          recordsVar = recordsVar.filter((item) =>
            (item?.name || "").toLowerCase().includes(headerSearch)
          );
        }

        if (branding === "iqops") {
          return (
            <View style={styles.screenShellIqops}>
              <View style={{ flex: 2 }} />
              <View
                className={"viewContainer"}
                style={[viewContainer(this.state.width, styles), styles.viewContainerIqops]}
              >
                <View style={styles.iqopsScreen}>
                  {this.state.showRecords ? (
                    <>
                      {this.renderIqopsFilterBubbles()}
                      {this.renderIqopsStatusModal()}
                      {this.renderIqopsDateRangeModal()}
                      {this.renderIqopsCustomDateModal()}

                      <View style={styles.iqopsListWrap}>
                        {!recordsLoading ? (
                          <FlatList
                            style={styles.iqopsList}
                            data={recordsVar}
                            renderItem={({ item }) => item ? this.Item(item) : null}
                            keyExtractor={(item, idx) => (item && item._id != null) ? String(item._id) : String(idx)}
                            contentContainerStyle={styles.iqopsListContent}
                            showsVerticalScrollIndicator={false}
                            ListEmptyComponent={
                              <Text style={{ textAlign: "center", marginTop: 20 }}>
                                No reports found
                              </Text>
                            }
                          />
                        ) : (
                          <View style={styles.centeredView}>
                            <Animations animationfile='loading-dots-gray' />
                          </View>
                        )}
                      </View>

                      {this.props.records?.records?.length > 0 ? (
                        <View style={styles.iqopsPaginatorWrap}>
                          <RecordPaginator
                            currentPage={currentPage}
                            filter={filter}
                            pageSize={pageSize}
                            tasksCount={records?.totalCount}
                            navigationHandler={({ page }) => this.filterRecords(page)}
                            totalLabel={`Total Records : ${records?.totalCount || 0}`}
                          />
                        </View>
                      ) : null}
                    </>
                  ) : null}
                </View>
              </View>
              <View style={{ flex: 2 }} />
            </View>
          );
        }

        else {
        return (

          <View style={{ flexDirection: "row" }}>
            <View style={{ flex: 2 }} />
            <View className={"viewContainer"} style={viewContainer(this.state.width, styles)} >
              {/* <TouchableOpacity
                onPress={() => {
                  if(tasksStatus != "loading" && !recordsLoading){
                    if (recordsVar) {
                      this.setState({ showRecords: !this.state.showRecords });
                      if (this.state.showRecords) {
                        this.setState({ btnName: "Show reports" });
                      } else {
                        this.setState({ btnName: "Hide reports" });
                      }
                    }
                  }       
                }}
                style={styles.appButtonContainer}
              >
                <Text style={styles.appButtonText}>{this.state.btnName}</Text>
              </TouchableOpacity> */}
              {this.state.showRecords ? (
                <View>
                  <TouchableOpacity onPress={() => this.setState({ filterOpen: true })} style={{ alignItems: 'center' }}>
                    <View style={{ flexDirection: "row", padding: 5 }}>
                      <MaterialCommunityIcons name={this.translateIcon(this.state.filter)} style={this.getIconStyle(this.state.filter)} />
                      <Text style={{ alignSelf: 'center', fontSize: 15, fontWeight: '600' }}>{this.translateStatus(this.state.filter)}</Text>
                    </View>
                  </TouchableOpacity>
                  <View style={styles.centeredView}>
                    <ModalWeb
                      animationType="none"
                      transparent={true}
                      visible={this.state.filterOpen}>

                      <View style={styles.centeredView}>
                        <View style={styles.modalView}>
                          <MaterialCommunityIcons onPress={() => {
                            this.setState({ filterOpen: false });
                            this.filterRecords(); 
                          }} name="close" style={styles.filterClose} />
                          <Text style={{ marginBottom: 10, fontWeight: '500' }}>Please select a filter:</Text>
                          <FlatList
                            data={recordTypes()}
                            renderItem={({ item }) => this.filterItem(item)}
                            keyExtractor={(item) => String(item?.value ?? '')}
                            onPress={() => {
                              this.setState({ filterOpen: false });
                              this.filterRecords(); 
                            }} 

                          />
                        </View>
                      </View>
                    </ModalWeb>

                  </View>
                  {(!recordsLoading && recordsVar?.length > 0) ?
                    <FlatList
                      data={recordsVar}
                      renderItem={({ item }) => item ? this.Item(item) : null}
                      keyExtractor={(item, idx) => (item && item._id != null) ? String(item._id) : String(idx)}
                    /> : null
                  }
                  {
                    this.props.records.records.length > 0 
                    ? <RecordPaginator currentPage={currentPage} filter={filter} pageSize={pageSize} tasksCount={records?.totalCount} navigationHandler={getAllRecords}/>
                    : <Text style={{ textAlign: 'center' }}>No reports found</Text>
                  }
                  {this.props.records.records.length > 0 && this.totalReports()}
                </View>
              ) : null}
              <Separator />
              {/* Logs feature intentionally disabled for this PR. To restore: uncomment this block and getAllTaskFromLog in componentDidMount (~line 105), or gate behind a feature flag. */}
              {/* <TouchableOpacity
                onPress={() => {
                  if(tasksStatus != "loading" && ! recordsLoading){
                    this.setState({ showLogs: !this.state.showLogs });
                    if (this.state.showLogs) {
                      this.setState({ btnNameLog: "Show Log reports" });
                    } else {
                      this.setState({ btnNameLog: "Hide Log reports" });
                    }
                  }
                }}
                style={styles.appButtonContainer}
              >
                <Text style={styles.appButtonText}>{this.state.btnNameLog}</Text>
              </TouchableOpacity> */}
              {/* {this.state.showLogs ? (
                <View>
                  <TouchableOpacity onPress={() => this.setState({ filterLogOpen: true })} style={{ alignItems: 'center' }}>
                    <View style={{ flexDirection: "row", padding: 5 }}>
                      <MaterialCommunityIcons name={this.translateIcon(this.state.filterLog)} style={this.getIconStyle(this.state.filterLog)} />
                      <Text style={{ alignSelf: 'center', fontSize: 15, fontWeight: '600' }}>{this.translateStatus(this.state.filterLog)}</Text>
                      <Text style={{ alignSelf: 'center', fontSize: 15, fontWeight: '600' }}> Log Reports</Text>
                    </View>
                  </TouchableOpacity>
                  <View style={styles.centeredView}>
                    <ModalWeb
                      animationType="none"
                      transparent={true}
                      visible={this.state.filterLogOpen}>
                      <View style={styles.centeredView}>
                        <View style={styles.modalView}>
                          <MaterialCommunityIcons onPress={() => {
                            this.setState({ filterLogOpen: false })
                            this.filterLogRecords();
                          }} name="close" style={styles.filterClose} />
                          <Text style={{ marginBottom: 10, fontWeight: '500' }}>Please select a filter:</Text>
                          <FlatList
                            data={recordTypes(true)}
                            renderItem={({ item }) => this.filterLogItem(item)}
                            keyExtractor={item => String(item?.value ?? '')}
                          />
                        </View>
                      </View>
                    </ModalWeb>

                  </View>
                  { tasksStatus !== "loading" && !recordsLoading ?
                    <View>
                      <FlatList
                            data={logRecords}
                            renderItem={({ item }) => this.TaskItem(item) }
                            keyExtractor={item => item._id.toString()}
                        />
                        { 
                          logRecords?.length > 0 
                          ? <RecordPaginator resultsPerPage={5} currentPage={currentLogPage} filter={filterLog} pageSize={logPageSize} tasksCount={taskLogCount} navigationHandler={getAllTaskFromLog}/>
                          : <Text style={{textAlign: 'center'}}>No log reports found</Text>}
                        { logRecords?.length > 0 && this.totalLogs() }
                    </View>
                    :
                    <View style={styles.centeredView}>
                      <Animations animationfile='loading-dots-gray' />
                    </View>
                  }

                </View>
              ) : null} */}
            </View>
            <View style={{ flex: 2 }} />
          </View>

        )
        }
    }
}

const mapStateToProps = (state) => {
    return {
      records: state.records.get('records'),
      logRecords: state.records.get('logRecords'), 
      recordsLoading:state.records.get('recordsLoading'),
      tasksStatus: state.tasks.get('status'),
      currentPage: state.tasks.get('currentPage'),
      tasksCount: state.tasks.get('tasksCount'),
      pageSize: state.tasks.get('pageSize'),
      currentLogPage: state.tasks.get('currentLogPage'),
      taskLogCount: state.tasks.get('taskLogCount'),
      logPageSize : state.tasks.get('logPageSize'),  
      taskLogTotal : state.tasks.get('taskLogTotal'),
      LogFilter: state.records.get('LogFilter'),
      approved: state.records.get('approved'),
      loadingRecord: state.records.get('loadingRecord'),
      headerSearch: state.user.get("headerSearch") || "",
    };
};

const Separator = () => (
  <View style={styles.separator} />
);

export default connect(mapStateToProps, (dispatch, props) => {
    return {
      getAllRecords: (params) => {
        dispatch(getAllRecords(params));
      },  
      getAllTaskFromLog: (params) => {
        dispatch(getAllTaskFromLog(params));
      },    
      setSubmissionSelected: (value) =>{
        dispatch(setSubmissionSelected(value));
      }, 
      getSubmission: (id, callback) =>{
        dispatch(getSubmission(id, callback));
      },
      setIsSubmission: (value) =>{
        dispatch(setIsSubmission(value));
      },
      navigateRecord: (id, name, newReport, isPallet, isReceivingLog, isOrder, isRecipe, defaultYield, isInvoice, isShipmentLog, isReconciliationLog, isInventoryTransfer, complete_date, isShipmentByLocation, isTransferByLocation) =>{
        props.navigation.navigate('FormView', { formId: id, title: name, newReport:newReport, submission: null, task_id: null, log_group_id:null, isPallet: isPallet, isReceivingLog: isReceivingLog, isOrder: isOrder, isRecipe: isRecipe, defaultYield: defaultYield, isInvoice: isInvoice, isShipmentLog: isShipmentLog, isReconciliationLog: isReconciliationLog, isInventoryTransfer: isInventoryTransfer, complete_date: complete_date, isShipmentByLocation: isShipmentByLocation, isTransferByLocation: isTransferByLocation });
      },
      setTaskSelected: (value) => {
        dispatch(setTaskSelected(value));
      },
      getGroupDetail: (id, sig) => {
        dispatch(getGroupDetail(id, sig));
      },
      setIsLogGroup: (val) => {
        dispatch(setIsLogGroup(val))
      },
      setFilter: (val) =>{
        dispatch(setLogFilter(val));
      },
      setPromptTitle: (val) =>{
        dispatch(setPromptTitle(val));
      },
      setFrom: (value) => {
        dispatch(setFrom(value));
      }
    };
})(Records);

const styles = StyleSheet.create({    
    filterItem: {
        flexGrow: 1,
        flexDirection: "row",
        backgroundColor: colors.filter,   
        borderRadius: 5,  
        marginBottom: 2,        
        marginHorizontal: 2,
        borderColor: "lightgray",
        borderWidth: 1,
        marginBottom: 2,       
    },  
    filterItemSelected: {
      flexGrow: 1,
      flexDirection: "row",
      backgroundColor: "#F5F5F5",         
      borderRadius: 5,  
      marginBottom: 2,        
      marginHorizontal: 2,
      borderColor: "lightgray",
      borderWidth: 2,
      marginBottom: 2,       
  },
    item: {
        flexDirection: "row",
        backgroundColor: 'lightgray',
        backgroundColor: '#fff',   
        borderRadius: 5,  
        marginBottom: 2,        
        marginHorizontal: 2,
    },
    itemsBody: {
        flexDirection: "row",
        backgroundColor: 'lightgray',                    
        backgroundColor: '#fff',        
        flexGrow: 1,        
    },
    itemsFooter: {
        flexDirection: "row",
        backgroundColor: 'lightgray',              
        backgroundColor: '#fff',     
    },
    smartBox: {
        flexGrow: 1,
        justifyContent: "center",
    },
    centeredView: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",                 
    },
    modalView: {
      height: 370,      
      margin: 20,
      backgroundColor: "white",
      borderRadius: 20,
      padding: 35,
      alignItems: "center",
      shadowColor: "#000",
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5
    },
    iconContainer: {         
        justifyContent: "center",
    },  
    recordContainer: {
        flexGrow: 1, 
        
        justifyContent: "center",
    },       
    iconInProgress: {    
      marginHorizontal: 10,
      fontSize: 30,         
      alignSelf: "center", 
      color: colors.in_progress,
      
    },
    iconDefault:{
      marginHorizontal: 10,
      fontSize: 30,         
      alignSelf: "center", 
      color: "#7B7F7F",
    },
    filterClose: {    
      marginHorizontal: 10,
      fontSize: 30,         
      alignSelf: "center", 
      color: 'lightgray',
      position: 'absolute',
      top: 5,
      right: 0,
    
    },
    iconEditRequired: {    
      marginHorizontal: 10,
      fontSize: 30,         
      alignSelf: "center", 
      color: colors.edit_required,
    },
    iconReadyForReview: {    
      marginHorizontal: 10,
      fontSize: 30,         
      alignSelf: "center", 
      color: colors.complete,
    },
    iconReadyForApproval: {    
      marginHorizontal: 10,
      fontSize: 30,         
      alignSelf: "center", 
      color: colors.approved,
    },
    iconApproved: {    
      marginHorizontal: 10,
      fontSize: 30,         
      alignSelf: "center", 
      color: 'lightgreen',
    },   
    iconArchived: {    
      marginHorizontal: 10,
      fontSize: 30,         
      alignSelf: "center", 
      color: colors.archived,
    },
    recordName: {      
        fontSize: 15,
        marginTop: 10,
        marginRight:2,
        fontWeight: "bold",
        textAlign: "left",
        alignSelf: "flex-start",
    },   
    transactionPeer: {      
        fontSize: 18,
        marginTop: 1, 
        color: "gray",    
        alignSelf: "flex-start",
    },
    recordDate: {
        fontSize: 18,
        marginTop: 1,     
        color: "gray",
        alignSelf: "flex-end",
    },
    topBar: {
      paddingVertical: 20,
      backgroundColor: colors.primary,
      justifyContent: "center",
      alignItems: "center",
      shadowOffset: {
        width: 0,
        height: 5,
      },
      shadowRadius: 5,
      shadowOpacity: 0.2,
      shadowColor: "black",
      zIndex: 10,
    },
    appButtonContainer: {
      elevation: 8,
      backgroundColor: "#cfd8dc",
      paddingVertical: 16,
      paddingHorizontal: 12,
    },
    appButtonText: {
      fontSize: 14,
      color: colors.primary,
      fontWeight: "bold",
      alignSelf: "center",
      textTransform: "uppercase",
    },
    separator: {
      marginVertical: 20,
      borderBottomColor: colors.primary,
      borderBottomWidth: StyleSheet.hairlineWidth,
    },
    viewContainerMax: {
      flex: 2, 
      backgroundColor: '#fff', 
      borderRadius: 20, 
      marginTop: 10,
      minWidth: '80%',
      paddingTop: 50,
      paddingLeft: 50,
      paddingRight: 50,
    },
    viewContainerMax1: {
      flex: 2, 
      backgroundColor: '#fff', 
      borderRadius: 20, 
      marginTop: 10,
      minWidth: 450,
      paddingTop: 20,
      paddingLeft: 15,
      paddingRight: 15,
    },
    viewContainerMax2: {
      flex: 2, 
      backgroundColor: '#fff', 
      borderRadius: 20, 
      marginTop: 10,
      minWidth: 350,
      paddingTop: 50,
      paddingLeft: 10,
      paddingRight: 10,
    },
    viewContainerMax3: {
      flex: 2, 
      backgroundColor: '#fff', 
      borderRadius: 20, 
      marginTop: 10,
      minWidth: 300,
      paddingTop: 50,
      paddingLeft: 10,
      paddingRight: 10,
    },
  screenShellIqops: {
    flex: 1,
    flexDirection: "row",
    height: "100%",
    maxHeight: "100%",
    overflow: "hidden",
    backgroundColor: "#FFFFFF",
  },
  viewContainerIqops: {
    flex: 2,
    height: "100%",
    maxHeight: "100%",
    overflow: "hidden",
    marginTop: 0,
    borderRadius: 0,
    paddingTop: 8,
    backgroundColor: "#FFFFFF",
  },
  iqopsScreen: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
    backgroundColor: "#FFFFFF",
  },
  iqopsFilterScroll: {
    flexGrow: 0,
    flexShrink: 0,
  },
  iqopsFilterScrollContent: {
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 10,
    alignItems: "center",
  },
  iqopsFilterBubble: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F3F4F6",
    borderRadius: 20,
    paddingVertical: 8,
    paddingHorizontal: 14,
    marginRight: 10,
    borderWidth: 1,
    borderColor: "#E8EEF5",
  },
  iqopsFilterBubbleActive: {
    backgroundColor: "#5A5A5A",
    borderColor: "#5A5A5A",
  },
  iqopsFilterBubbleIconMci: {
    fontSize: 18,
    color: "#5A6578",
    marginRight: 6,
  },
  iqopsFilterBubbleIconMciActive: {
    color: "#FFFFFF",
  },
  iqopsFilterBubbleIconImg: {
    width: 18,
    height: 18,
    marginRight: 6,
  },
  iqopsFilterBubbleIconImgActive: {
    tintColor: "#FFFFFF",
  },
  iqopsFilterBubbleLabel: {
    fontSize: 14,
    fontWeight: "600",
    color: "#1A1A1A",
    maxWidth: 120,
  },
  iqopsFilterBubbleLabelActive: {
    color: "#FFFFFF",
  },
  iqopsFilterSubBubble: {
    backgroundColor: "#FFFFFF",
    borderColor: "#D1D5DB",
  },
  iqopsFilterSubBubbleActive: {
    backgroundColor: "#F3F4F6",
    borderColor: "#5A5A5A",
  },
  iqopsFilterSubBubbleLabel: {
    maxWidth: 160,
    fontWeight: "500",
  },
  iqopsFilterSubBubbleLabelActive: {
    color: "#1A1A1A",
    fontWeight: "700",
  },
  iqopsFilterSubBubbleIconActive: {
    color: "#1A1A1A",
  },
  iqopsStatusModalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.18)",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 28,
  },
  iqopsStatusModalCard: {
    width: "100%",
    maxWidth: 340,
    backgroundColor: "#FFFFFF",
    borderRadius: 14,
    borderWidth: 1.5,
    borderColor: "#A8C8E8",
    paddingTop: 14,
    paddingBottom: 8,
    paddingHorizontal: 14,
    shadowColor: "#0b4dad",
    shadowOpacity: 0.12,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 },
    elevation: 6,
  },
  iqopsStatusModalHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
    paddingHorizontal: 4,
  },
  iqopsStatusModalTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: "#4B5563",
  },
  iqopsStatusModalClose: {
    fontSize: 26,
    color: "#7EB6E8",
  },
  iqopsStatusModalList: {
    paddingBottom: 4,
  },
  iqopsStatusDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: "#E5E7EB",
    marginLeft: 44,
  },
  iqopsStatusRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
    paddingHorizontal: 8,
    borderRadius: 8,
  },
  iqopsStatusRowSelected: {
    backgroundColor: "#E8E8E8",
  },
  iqopsStatusRowBadge: {
    width: 28,
    height: 28,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  iqopsStatusRowBadgeIcon: {
    fontSize: 16,
    color: "#FFFFFF",
  },
  iqopsStatusRowLabel: {
    fontSize: 16,
    fontWeight: "500",
    color: "#1A1A1A",
  },
  iqopsStatusRowLabelSelected: {
    fontWeight: "700",
    color: "#1A1A1A",
  },
  iqopsDateRangeModalCard: {
    maxHeight: "75%",
  },
  iqopsDateRangeModalHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 8,
    paddingHorizontal: 4,
    minHeight: 32,
  },
  iqopsDateRangeModalTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: "#4B5563",
    textAlign: "center",
  },
  iqopsDateRangeModalCloseBtn: {
    position: "absolute",
    right: 0,
    top: 0,
  },
  iqopsDateRangeList: {
    maxHeight: 420,
  },
  iqopsDateRangeDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: "#E5E7EB",
  },
  iqopsDateRangeRow: {
    paddingVertical: 14,
    paddingHorizontal: 8,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  iqopsDateRangeRowLabel: {
    fontSize: 16,
    fontWeight: "500",
    color: "#1A1A1A",
    textAlign: "center",
    width: "100%",
  },
  iqopsCustomDateModalCard: {
    maxWidth: 360,
    paddingBottom: 16,
  },
  iqopsCustomRangeLabelRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 12,
  },
  iqopsCustomRangeLabel: {
    fontSize: 16,
    fontWeight: "600",
    color: "#1A1A1A",
    marginRight: 8,
  },
  iqopsCustomRangeEditIcon: {
    fontSize: 18,
    color: colors.primary,
  },
  iqopsCalendarWrap: {
    paddingHorizontal: 4,
    marginBottom: 16,
  },
  iqopsCalendarHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  iqopsCalendarMonthLabel: {
    fontSize: 16,
    fontWeight: "600",
    color: "#1A1A1A",
  },
  iqopsCalendarNavIcon: {
    fontSize: 28,
    color: colors.primary,
  },
  iqopsCalendarWeekRow: {
    flexDirection: "row",
    marginBottom: 4,
  },
  iqopsCalendarWeekDay: {
    width: `${100 / 7}%`,
    textAlign: "center",
    fontSize: 12,
    fontWeight: "600",
    color: "#9AA3AF",
  },
  iqopsCalendarGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  iqopsCalendarDayCell: {
    width: `${100 / 7}%`,
    aspectRatio: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  iqopsCalendarDayInRange: {
    backgroundColor: "#D7EBFA",
  },
  iqopsCalendarDayRangeStart: {
    borderTopLeftRadius: 18,
    borderBottomLeftRadius: 18,
  },
  iqopsCalendarDayRangeEnd: {
    borderTopRightRadius: 18,
    borderBottomRightRadius: 18,
  },
  iqopsCalendarDayInner: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  iqopsCalendarDayInnerSelected: {
    backgroundColor: colors.primary,
  },
  iqopsCalendarDayText: {
    fontSize: 14,
    color: "#1A1A1A",
    fontWeight: "500",
  },
  iqopsCalendarDayTextMuted: {
    color: "#C0C4CC",
  },
  iqopsCalendarDayTextSelected: {
    color: "#FFFFFF",
    fontWeight: "700",
  },
  iqopsCustomApplyBtn: {
    alignSelf: "center",
    minWidth: 160,
    borderWidth: 1.5,
    borderColor: colors.primary,
    borderRadius: 24,
    paddingVertical: 10,
    paddingHorizontal: 28,
    alignItems: "center",
    marginTop: 4,
  },
  iqopsCustomApplyBtnText: {
    color: colors.primary,
    fontSize: 16,
    fontWeight: "700",
  },
  iqopsListWrap: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  iqopsList: {
    flex: 1,
  },
  iqopsListContent: {
    paddingBottom: 120,
    paddingTop: 4,
  },
  iqopsPaginatorWrap: {
    flexShrink: 0,
    backgroundColor: "#FFFFFF",
    paddingBottom: 100,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: "#E8EEF5",
  },
  iqopsCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: 14,
    borderWidth: 1,
    borderColor: "#E8EEF5",
    marginHorizontal: 16,
    marginTop: 10,
    paddingVertical: 14,
    paddingHorizontal: 14,
    shadowColor: "#0b4dad",
    shadowOpacity: 0.06,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
  },
  iqopsStatusBadge: {
    width: 36,
    height: 36,
    borderRadius: 18,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  iqopsStatusIcon: {
    fontSize: 22,
    color: "#FFFFFF",
  },
  iqopsCardBody: {
    flex: 1,
    paddingRight: 8,
  },
  iqopsRecordName: {
    fontSize: 15,
    fontWeight: "700",
    color: "#1A1A1A",
    marginBottom: 4,
  },
  iqopsCreatedAt: {
    fontSize: 12,
    color: "#9AA3AF",
  },
  iqopsUpdatedAt: {
    fontSize: 12,
    color: "#9AA3AF",
    alignSelf: "flex-start",
    marginTop: 2,
  },

});
